import React from "react"
import { connect } from 'react-redux'
import { Row, Col, Table } from 'react-bootstrap'
import SusceptibilityTestRow from './SusceptibilityTestRow'
import { PulseLoader } from 'react-spinners'

import InfoIconOverlay from '../../../components/InfoIconOverlay'

const SusceptibilityTestTable = (props) => {

  const {
    pathogen,
    handleRemoveSusceptibilityTest,
    susceptibilityDrugOptions,
    chartForReview,
    patchSusceptibilityTest,
    handleSusceptibilityTestBlur,
    micOrZoneOptions,
    interpretationOptions,
    currentUser,
    addingNewSusceptibilityTest,
    site,
  } = props


  // const getInterpretationValue = (drugName) => {
  //   const existingSusceptibilityTest = props.pathogen.susceptibility_tests.find(test => test.drug_name === drugName)
  //   if (existingSusceptibilityTest.interpretation) {
  //     return existingSusceptibilityTest.interpretation
  //   } else {
  //     return ''
  //   }
  // }

  return (
    <Row>
      <Col xs={12} sm={12} md={12} lg={12}>
        <Table striped bordered responsive>
          <thead>
            <tr>
              <th></th>
              <th>
                <center>
                Drugs tested
                </center>
              </th>

              <th>
                <center>
                Interpretation
                <br/>
                S=Susceptible
                <br/>
                I=Intermediate
                <br/>
                R=Resistant
                <br/>
                NI=Not Interpretable or Not Interpreted
                </center>
              </th>

              <th>
                <center>
                MIC or Zone size if reported
                <InfoIconOverlay 
                  text={
                    <>    
                      <p>
                        Please enter the MIC and/or Zone size when available. For cefiderocol, if neither of these values is available, please check the "MIC and Zone size not available" box.
                      </p>
                      <p>
                        "MIC and Zone size not available" is only present if the CFDC interpretation is "NI"
                      </p>
                      <p>
                        For all other drugs, enter "N/A" in either the MIC or Zone size field if neither is available.
                      </p>
                    </>
                  }
                />
                </center>
              </th>
            </tr>
          </thead>

          <tbody>
            {pathogen.susceptibility_tests ?
              <>
                {pathogen.susceptibility_tests.map(susceptibilityTest => {
                  return (
                    <SusceptibilityTestRow
                      key={susceptibilityTest.id}
                      susceptibilityTest={susceptibilityTest}
                      micOrZoneOptions={micOrZoneOptions}
                      interpretationOptions={interpretationOptions}
                      chartForReview={chartForReview}
                      pathogen={pathogen}
                      site={site}
                      patchSusceptibilityTest={patchSusceptibilityTest}
                      susceptibilityDrugOptions={susceptibilityDrugOptions}
                      // getInterpretationValue={getInterpretationValue}
                      handleSusceptibilityTestBlur={handleSusceptibilityTestBlur}
                      handleRemoveSusceptibilityTest={handleRemoveSusceptibilityTest}
                      currentUser={currentUser}
                      savingChartPhase={props.savingChartPhase}
                      handleShowCustomOptionModal={props.handleShowCustomOptionModal}
                    />
                  )
                })}

                {addingNewSusceptibilityTest ?
                  <tr className='loading-table-row'>
                    <td colSpan={4} className='loading-table-row-overlay'>
                      <center>
                        <PulseLoader
                          css={`display: block; margin: 80px auto 0 auto;`}
                          sizeUnit={"px"}
                          size={20}
                          color='#cf1a28'
                        />
                        <p>Saving...</p>
                      </center>
                    </td>
                  </tr>
                  :
                  null
                }
              </>
            :
              <tr>
                <td colSpan={4}>You have no susceptibility tests selected. Please select one from the dropdown below.</td>
              </tr>
            }
          </tbody>
        </Table>
      </Col>
    </Row>
  )
}

const mapStateToProps = (state) => {
  return {
    addingNewSusceptibilityTest: state.infectionCourseFormReducer.addingNewSusceptibilityTest,
  }
}

export default connect(mapStateToProps)(SusceptibilityTestTable)
